import styled from 'styled-components';
import PropTypes from 'prop-types';

const UIDivider = styled.div`
  width: 48px;
  height: 6px;
  background: ${props => props.color};
  margin-bottom: ${props => props.noBottomMargin ? '0' : '20px'};
  @media screen and (min-width: 768px) {
    margin-bottom: ${props => props.noBottomMargin
      ? '0'
      : (props.responsiveMargin ? '16px' : '28px')};
  }
  @media screen and (min-width: 992px) {
    margin-bottom: ${props => props.noBottomMargin ? '0' : '28px'};
  }
`;

if (process.env.NODE_ENV !== 'production') {
  UIDivider.propTypes = {
    color: PropTypes.string,
    noBottomMargin: PropTypes.bool,
    responsiveMargin: PropTypes.bool
  };
}

UIDivider.defaultProps = {
  color: '#131313',
  noBottomMargin: false,
  responsiveMargin: false
};

export default UIDivider;
